import { commitMutation as relayCommitMutation } from '@feedback/relay';

import type { MutationConfig } from 'relay-runtime';

import Environment from './Environment';

export const commitMutation = (config: MutationConfig) => {
  return relayCommitMutation(Environment, config);
};
